import { Typography } from '@mui/material'

import { useSeparatorStyles } from './Separator.styles'

export type SeparatorSize = 'NONE' | 'XXS' | 'XS' | 'S' | 'M' | 'L' | 'XL'
export type horizontalMarginSize = SeparatorSize
type BorderType = 'fullWidth' | 'withGutters'

export interface SeparatorProps {
  size?: SeparatorSize
  text?: string
  borderType?: BorderType
  hasWhiteBackground?: boolean
  horizontalMargin?: horizontalMarginSize
}

export const Separator = ({
  size = 'L',
  text,
  borderType,
  hasWhiteBackground,
  horizontalMargin,
}: SeparatorProps): JSX.Element => {
  const { cx, classes } = useSeparatorStyles()

  const hasText = !!text

  return (
    <div
      className={cx({
        [classes.none]: size === 'NONE',
        [classes.xxs]: size === 'XXS',
        [classes.xs]: size === 'XS',
        [classes.s]: size === 'S',
        [classes.m]: size === 'M',
        [classes.l]: size === 'L',
        [classes.xl]: size === 'XL',
        [classes.horizontalMarginXs]: horizontalMargin === 'XS',
        [classes.horizontalMarginS]: horizontalMargin === 'S',
        [classes.horizontalMarginM]: horizontalMargin === 'M',
        [classes.horizontalMarginL]: horizontalMargin === 'L',
        [classes.horizontalMarginXl]: horizontalMargin === 'XL',
        [classes.border]: borderType === 'fullWidth',
        [classes.borderWithGutters]: borderType === 'withGutters',
        [classes.padding]: hasText,
        [classes.hasWhiteBackground]: hasWhiteBackground,
      })}
    >
      {hasText && <Typography variant="caption">{text}</Typography>}
    </div>
  )
}
